import React, { CSSProperties } from "react";
import { getRoutePath, RouteParamsType } from "@/routes.ts";
import { useRouter } from "next/navigation";

interface EllipsisLinkProps {
  onClick?: (e: React.MouseEvent) => void;
  maxWidth?: string | number;
  textContent: string;
  routeName?: string;
  routeParams?: RouteParamsType;
  routePath?: string;
  className?: string;
  style?: CSSProperties;
}

const EllipsisLink: React.FC<EllipsisLinkProps> = (
  {
    className,
    style,
    maxWidth,
    textContent,
    routeName,
    routeParams,
    routePath,
    onClick,
  }) => {
  const router = useRouter()
  const spanStyle: React.CSSProperties = {
    maxWidth: maxWidth || "100%",
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'inline-block'
  };

  const extraStyles = style ?? {}

  return <a
    href={'#'}
    onClick={(e: React.MouseEvent) => {
      e.preventDefault();
      if (onClick) {
        onClick(e)
        return;
      }

      if (routeName) {
        router.push(getRoutePath(routeName, routeParams))
      }
      if (routePath) {
        router.push(routePath)
      }
    }}
    className={`${className} link`}
    style={{ ...spanStyle, ...extraStyles }}
    title={textContent}>
    {textContent}
  </a>
}

export default EllipsisLink;
